export default class FiscalPrinterService {
  constructor($http, host) {
    this.http = $http;
    this.host = host;
  }

}

 FiscalPrinterService.$inject = ['$http', 'host'];



// WEBPACK FOOTER //
// ./src/app/services/fiscal-printer.service.js